document.addEventListener("input", (event) => {
  const input = event.target.closest("[data-filter]")
  if (!input) return

  const terms = input.value.toLowerCase().split(/\s+/).filter(Boolean).map((term) => (term.length > 3 && term.endsWith("s") ? term.slice(0, -1) : term))
  const items = [...document.querySelectorAll("[data-filter-text]")]
  const shown = new Set(items.filter((item) => terms.every((term) => item.dataset.filterText.includes(term))).map((item) => item.dataset.filterKey))

  document.querySelectorAll("[data-filter-key]").forEach((element) => element.classList.toggle("hidden", !shown.has(element.dataset.filterKey)))
  document.querySelectorAll("[data-filter-group]").forEach((group) => group.classList.toggle("hidden", !group.querySelector("[data-filter-key]:not(.hidden)")))
  document.querySelectorAll("[data-filter-empty]").forEach((empty) => empty.classList.toggle("hidden", shown.size > 0))
})
